import { Box } from "@mui/material";
import { JSX } from "react";
import { Typography } from "@platform/design-system";

import ConnectedCarrierIcon from "./connectedCarrierIcon";

function ConnectedCarrierBanner(): JSX.Element {
  return (
    <Box
      sx={{
        padding: "1rem",
        display: "flex",
        alignItems: "center",
        gap: "1.5rem",
        backgroundColor: "surfaces.primary",
        marginBottom: "1rem",
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          backgroundColor: "white",
          padding: "0.25rem 0.5rem",
          minWidth: "max-content",
          height: "100%",
          borderRadius: "1rem",
          gap: "0.37rem",
          border: "1px solid",
          borderColor: "white",
        }}
      >
        <ConnectedCarrierIcon />{" "}
        <Typography component="span">
          <strong>Connected Carrier</strong>
        </Typography>
      </Box>
      <Typography>
        Policy data is now available from Connected Carriers. Click “View Policy
        Details” to access.
      </Typography>
    </Box>
  );
}

export default ConnectedCarrierBanner;
